module.exports = __webpack_public_path__ + "media/images/blue-checkbox-unchecked-079878c483fdfd3c55c20b5244266175.svg";